import React, { Component } from "react";
import { toast } from "react-toastify";
import dateFns from "date-fns";
import axios from "../../configAxios";
import DatePicker from "../UI/datePicker";
import Button from "../UI/button/Button";
import FormButton from "../UI/button/FormButton";
import errorStatusHandler from "../errorPages/UserNotAuthorized";

// addYears gives Feb 28 from Feb 29, as Ruby Date + 1.year does on the server.
const oneYearFromToday = () => dateFns.format(dateFns.addYears(new Date(), 1), "MMM DD YYYY");

const MEMBER_RENEWAL_FAILED = "The membership could not be renewed. Please try again or contact us.";

class UpdateExpiryDate extends Component {
  state = {
    date: {
      elementType: "input",
      elementConfig: {
        name: "date",
        placeholder: "Ex- Sep 30 2007",
        components: {
          IndicatorSeparator: () => {
            return null;
          }
        },
        required: true
      },
      value: ""
    },
    invoice: false,
    disabled: false
  };
  closeModal = () => {
    this.props.closeModal();
  };

  componentDidMount() {
    let oneYearFromNow = oneYearFromToday();
    if (this.props.user.membership_expires === null) {
      this.setState({
        ...this.state,
        date: {
          ...this.state.date,
          value: oneYearFromNow
        }
      })
    }
  }

  componentWillMount() {
    let date = { ...this.state.date };
    date["value"] = this.props.expiryDate
    this.setState({ date: date });
  }

  inputChangedHandler = newDate => {
    let date = { ...this.state.date };
    date["value"] = newDate;
    this.setState({ date: date });
  };

  // sc-37887: a member renews their own expired membership. The server sets the
  // date (12 months from today) and always makes the invoice.
  memberSubmitHandler = event => {
    event.preventDefault();
    this.setState({ disabled: true });
    axios
      .put("/users/renew_membership")
      .then(res => {
        if (res.data.json.success) {
          this.props.closeModal();
          toast.success("Membership renewed. Please pay the invoice.");
          this.props.onMemberRenewed(res.data.json.id);
        } else {
          if (res.data.json.errors || res.data.json.error) {
            errorStatusHandler(res);
          } else {
            toast.error(MEMBER_RENEWAL_FAILED);
          }
          this.setState({ disabled: false });
        }
      })
      .catch(error => {
        // For an HTTP error the axios interceptor already shows the error page.
        if (error.response) return;
        toast.error(MEMBER_RENEWAL_FAILED);
        this.setState({ disabled: false });
      });
  };

  submitHandler = event => {
    event.preventDefault();
    this.setState({ disabled: true })
    let date = {
      id: parseInt(this.props.id),
      new_expiration_date: this.state.date.value,
      create_invoice: this.state.invoice
    };

    axios
      .put("/users/update_membership_expiration", date)
      .then(res => {
        if (res.data.json.success) {
          this.props.renew(this.state.date.value);
          let message = "Expiration date updated Successfully";
          this.props.closeModal();
          toast.success(message);
        } else {
          errorStatusHandler(res);
          this.setState({ disabled: false })
        }
      })
      .catch(error => {
        // For an HTTP error the axios interceptor already shows the error page.
        if (error.response) return;
        toast.error("The expiration date could not be updated. Please try again.");
        this.setState({ disabled: false });
      });
  }

  selectHandler = () => {
    this.setState({ invoice: !this.state.invoice });
  };

  renderMemberRenewal() {
    return (
      <form onSubmit={this.memberSubmitHandler} className="mt-4">
        <p>New Expiration Date</p>
        <p className="font-weight-bold">{oneYearFromToday()}</p>
        <div className="d-flex align-items-center mb-3">
          <input id="member-renewal-invoice" type="checkbox" checked disabled readOnly />
          <label htmlFor="member-renewal-invoice" className="ml-2 mb-0">Create an Invoice ?</label>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            type="secondary"
            className="float-left mr-3"
            clicked={this.props.closeModal}
          >
            Cancel
          </Button>
          <FormButton disabled={this.state.disabled}>Renew</FormButton>
        </div>
      </form>
    );
  }

  render() {
    if (this.props.memberRenewal) {
      return this.renderMemberRenewal();
    }
    return (
      <form onSubmit={this.submitHandler} className="mt-4">
        <p>New Expiration Date</p>
        <DatePicker changed={this.inputChangedHandler} selected={new Date(this.state.date.value)} />
        <div className="d-flex" onClick={this.selectHandler}>
          <div
            style={{
              width: 20,
              height: 20,
              borderRadius: "50%",
              border: this.state.invoice
                ? "6px solid #1aff1a"
                : "1px solid #cccccc",
              cursor: "pointer"
            }}
          />
          <p className="ml-2 cursor">Create an Invoice ?</p>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            type="secondary"
            className="float-left mr-3"
            clicked={this.props.closeModal}
          >
            Cancel
          </Button>
          <FormButton disabled={this.state.disabled}>Submit</FormButton>
        </div>
      </form>
    );
  }
}
export default UpdateExpiryDate;
